/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.repo.getRecord'

export { $nsid }

/** Get a single record from a repository. Does not require auth. */
const main = l.query(
  $nsid,
  l.params({
    repo: l.string({ format: 'at-identifier' }),
    collection: l.string({ format: 'nsid' }),
    rkey: l.string({ format: 'record-key' }),
    cid: l.optional(l.string({ format: 'cid' })),
  }),
  l.jsonPayload({
    uri: l.string({ format: 'at-uri' }),
    cid: l.optional(l.string({ format: 'cid' })),
    value: l.lexMap(),
  }),
  ['RecordNotFound'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
